export interface LinearFit {
  slope: number;
  intercept: number;
}

/**
 * Ordinary least-squares linear fit through (x, y) points. Returns null when
 * there are fewer than 2 points or the x-values have zero variance (degenerate,
 * vertical fit), so callers can skip drawing a trend line rather than divide by
 * zero. Shared so the HRV trend line and the scatter regression stay consistent.
 */
export const linearFit = (points: { x: number; y: number }[]): LinearFit | null => {
  if (points.length < 2) return null;
  const n = points.length;
  const sumX = points.reduce((s, p) => s + p.x, 0);
  const sumY = points.reduce((s, p) => s + p.y, 0);
  const sumXY = points.reduce((s, p) => s + p.x * p.y, 0);
  const sumXX = points.reduce((s, p) => s + p.x * p.x, 0);
  const denom = n * sumXX - sumX * sumX;
  if (denom === 0) return null;
  const slope = (n * sumXY - sumX * sumY) / denom;
  const intercept = (sumY - slope * sumX) / n;
  return { slope, intercept };
};
